<template>
  <div class="notice-list">
    <associationNotice @changePage="changePage" @click="toDetails" :list="notice" :total="noticeTotal" v-loading="loading"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue'
import {mapMutations} from 'vuex'
import {findRoute} from '@/utils/routerHelper.js'
import {dynamics} from '@/api/api.js';
export default {
  components:{
    associationNotice
  },
  data(){
    return {
      loading:false,
      notice:[
        // {
        //   title:'关于攀枝花东区"银龄安居"为老服务项目2024年度中期评估结果的公示（第一批）',
        //   date:'2025-12-17',
        // },
        // {
        //   title:'关于攀枝花东区街道社工站2024年第一季度专业服务监测情况的通报',
        //   date:'2025-12-10',
        // },
        // {
        //   title:'关于攀枝花东区2023-2024年度优秀社区社会组织评选结果的公示',
        //   date:'2025-12-05',
        // },
        // {
        //   title:'关于攀枝花东区社会工作协会会员单位2024年度继续教育学时完成情况的公示',
        //   date:'2025-12-04',
        // },
        // {
        //   title:'关于攀枝花东区"阳光童年"儿童关爱项目末期评估与审计结果的联合公示',
        //   date:'2025-12-03',
        // },
        // {
        //   title:'关于攀枝花东区2024年度社会工作者职业水平考试考前培训优秀学员的公示',
        //   date:'2025-12-02',
        // },
        // {
        //   title:'关于攀枝花东区社会工作案例库（2024年第二季度）入选案例的公示',
        //   date:'2025-12-02',
        // },
        // {
        //   title:'关于攀枝花东区"五社联动"示范点创建项目中期评估结果的公示',
        //   date:'2025-12-02',
        // },
        // {
        //   title:'关于攀枝花东区社会工作服务项目承接机构备案名单（2024年度第一批）的公示',
        //   date:'2025-12-01',
        // },
        // {
        //   title:'关于攀枝花东区社会工作协会专业委员会新增委员人选名单的公示',
        //   date:'2025-12-01',
        // },
      ],
      noticeTotal:0,
      currentPage:1
    }
  },
  created(){
    this.getList()
  },
  methods:{
    ...mapMutations('routerData',['changeRouterList']),
    getList(){
      dynamics({
        current:this.currentPage,
        size:10,
        type:12
      }).then(res=>{
        if(res.data.code==200){
          this.noticeTotal=res.data.data.total
          this.notice=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
        }
      })
    },
    toDetails(data){
      this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
      )
      let routerList=[]
      let routers = ['/specialColumn','specialColumnInformationDisclosure', '/associationNews/details'];
      for (let i = 0; i < routers.length; i++) {
        let routerData=findRoute(this.$router.options.routes, routers[i])
        routerList.push(routerData)
      }
      this.changeRouterList(routerList)
    },
    changePage(page){
      this.currentPage=page
      this.getInfo()
    },
    getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.notice-list {
  width: 100%;
}
</style>
